import { render } from "./AddChannelsModal.vue?vue&type=template&id=13ca7c18&scoped=true"
import script from "./AddChannelsModal.vue?vue&type=script&lang=js"
export * from "./AddChannelsModal.vue?vue&type=script&lang=js"

import "./AddChannelsModal.vue?vue&type=style&index=0&id=13ca7c18&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13ca7c18"]])

export default __exports__